export default __webpack_public_path__ + "static/media/requirements-notice.1f5ac08c.svg";